
import { ChevronDown,ChevronUp } from 'react-bootstrap-icons'; // or use Bootstrap icons

const BounceArrow = ({ 
    message = '', 
    variant = 'default', 
    position = 'right', // 'left' or 'right'
    direction = 'down', // 'up' or 'down'
    className = '' 
  }) => {
    // Choose the appropriate arrow icon based on direction
    const ArrowIcon = direction === 'up' ? ChevronUp : ChevronDown;
    
    return (
      <div style={{marginLeft: '55px', marginTop:"-20px"}} className={`bouncing-arrow-container ${variant === 'button' ? 'button-guide' : ''} ${position === 'left' ? 'arrow-left' : ''} ${direction === 'up' ? 'arrow-up' : ''} ${className}`}>
        <ArrowIcon 
          className={`bouncing-arrow ${direction === 'up' ? 'bounce-up' : ''} ${
            variant === 'success' ? 'text-success' : 'text-primary'
          }`} 
          size={35} 
        />
        {/* <div className={`guide-tooltip ${variant === 'success' ? 'success' : ''} ${position === 'left' ? 'tooltip-right' : ''} ${direction === 'up' ? 'tooltip-below' : ''}`}>
          {message}
        </div> */}
      </div>
    );
  };

export default BounceArrow;